/** สถานะสลิป (miniapp_payments.status) */
export const slipPaymentStatusLabel: Record<string, string> = {
  submitted: 'รอตรวจสอบ',
  verified: 'อนุมัติแล้ว',
  rejected: 'ปฏิเสธแล้ว',
  expired: 'หมดเวลาชำระ',
  pending: 'รอชำระ',
};

export const slipPaymentStatusColor: Record<string, string> = {
  submitted: '#2563eb',
  verified: '#16a34a',
  rejected: '#dc2626',
  expired: '#57534e',
  pending: '#6b7280',
};

/** สถานะออเดอร์ (miniapp_orders.status) */
export const orderStatusLabel: Record<string, string> = {
  pending: 'รอดำเนินการ',
  paid: 'ชำระแล้ว',
  expired: 'หมดเวลาชำระ',
};

export const orderStatusColor: Record<string, string> = {
  pending: '#d97706',
  paid: '#16a34a',
  expired: '#57534e',
};
